module.exports = __webpack_public_path__ + "img/login_weixin.33114e27.svg";